import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=679a4ad9&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('679a4ad9')) {
      api.createRecord('679a4ad9', component.options)
    } else {
      api.reload('679a4ad9', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=679a4ad9&", function () {
      api.rerender('679a4ad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/currency/edit.vue"
export default component.exports